import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCustomDevto = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		fill='currentColor'
		viewBox='0 0 24 24'
		width='1em'
		height='1em'
		className='svg-icon'
		{...props}>
		<path d='M7.42 10.05c-.18-.16-.46-.23-.84-.23H6v6.07h.58c.44 0 .8-.11 1.05-.35.26-.24.38-.59.38-1.04v-3.45c0-.43-.13-.76-.38-.98zm13.37-7.27L12 3.36l-8.79-.58A1.24 1.24 0 0 0 2 4v16c0 .57.37 1.07.9 1.22l8.89 2.56a1.24 1.24 0 0 0 1.42-1.22V4.36l.03-.01 8.55.58A1.24 1.24 0 0 0 22 2.46zM8.5 15.64c-.4.39-.98.59-1.75.59H5.5V9.15h1.14c.83 0 1.46.22 1.87.66.4.44.61 1.1.61 1.97v1.89c0 .86-.2 1.52-.62 1.97M11 18h-1v-7h1zm3.22-2.39c0 .47-.16.84-.47 1.11s-.72.41-1.22.41c-.53 0-.96-.14-1.27-.41a1.33 1.33 0 0 1-.48-1.08v-.17h.91v.1c0 .2.06.38.18.52.13.14.3.21.53.21.22 0 .4-.06.53-.19s.19-.3.19-.52c0-.44-.36-.76-1.09-1.06-.72-.3-1.19-.55-1.42-.75a1.57 1.57 0 0 1-.48-1.2c0-.47.15-.85.46-1.12s.72-.41 1.24-.41c.53 0 .95.13 1.25.4.31.27.46.64.46 1.11v.14h-.91v-.08c0-.2-.06-.36-.17-.49a.62.62 0 0 0-.49-.19q-.3 0-.48.18a.63.63 0 0 0-.18.46c0 .17.06.31.17.42s.33.24.68.39l.5.21c.47.2.8.43 1 .7s.3.6.3 1.01z' />
	</svg>
);
export default SvgCustomDevto;
